import { react2angular } from 'react2angular';
import angular from 'angular';

import offerRoutes from './offer.routes';
import OfferSettings from './OfferSettings/OfferSettings';
import OfferEdit from './OfferEdit/OfferEdit';
import OfferMessageRecipient from './OfferMessageSentPage/OfferMessageRecipients';

angular
  .module('bb.offer', ['ngRoute'])
  .config(offerRoutes)
  .component(
    'bbOfferSettings',
    react2angular(
      OfferSettings,
      [],
      ['$rootScope', '$routeParams', 'ModalService', 'ToastService'],
    ),
  )
  .component(
    'bbOfferEdit',
    react2angular(
      OfferEdit,
      ['isNew'],
      ['$rootScope', '$routeParams', 'ModalService', 'ToastService'],
    ),
  )
  .component(
    'offerMessageRecipients',
    react2angular(OfferMessageRecipient, ['listingId', 'propertyAnnouncement']),
  );
